module.exports = __webpack_public_path__ + "static/media/companyGlobal.16877f3b.jpg";